import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { PhoneField } from '../PhoneField';
import { FormFieldGroupLayout } from '../FieldGroupLayout';
import { EKeyCode } from '../../types/keyCodes';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function PhoneAuthForm(_ref) {
  var phoneRef = _ref.phoneRef,
    isSubmitting = _ref.isSubmitting,
    autoFocusDisabled = _ref.autoFocusDisabled,
    phone = _ref.phone,
    onPhoneChange = _ref.onPhoneChange,
    phoneError = _ref.phoneError,
    isPhoneInvalid = _ref.isPhoneInvalid,
    handleSubmit = _ref.handleSubmit,
    onSwitchAuthType = _ref.onSwitchAuthType,
    isBlocked = _ref.isBlocked;
  var handlePreventSubmit = React.useCallback(function (e) {
    e.preventDefault();
  }, []);
  var handleSubmitOnEnter = React.useCallback(function (e) {
    if (e.keyCode === EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handlePreventSubmit,
    children: /*#__PURE__*/_jsx(FormFieldGroupLayout, {
      content: /*#__PURE__*/_jsx(PhoneField, {
        autoComplete: "tel",
        autoFocus: !autoFocusDisabled,
        name: "tel",
        inputRef: phoneRef,
        value: phone,
        onKeyDown: handleSubmitOnEnter,
        onValueChange: onPhoneChange,
        disabled: isSubmitting || isBlocked,
        invalid: isPhoneInvalid,
        errorMessage: phoneError,
        placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"
      }),
      buttons: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-name": "ContinueAuthBtn",
          type: "submit",
          theme: "fill_primary",
          loading: isSubmitting,
          disabled: isSubmitting || isBlocked,
          onClick: handleSubmit,
          fullWidth: true,
          children: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0434"
        }), /*#__PURE__*/_jsx(Button, {
          "data-name": "SwitchToEmailAuthBtn",
          theme: "fill_secondary",
          onClick: onSwitchAuthType,
          fullWidth: true,
          children: "\u0414\u0440\u0443\u0433\u043E\u0439 \u0441\u043F\u043E\u0441\u043E\u0431"
        })]
      })
    })
  });
}